import { StringParam, useQueryParam, withDefault } from "next-query-params";
import Searchbar from "@/components/search-bar";

export const JobSearchBar = () => {
  const [searchValue, setSearchValue] = useQueryParam(
    "search",
    withDefault(StringParam, "")
  );

  return (
    <Searchbar
      ariaLabel="Search for jobs"
      onChange={(v) => {
        setSearchValue(v, "replaceIn");
      }}
      value={searchValue}
      placeholder="Search..."
      position="right"
    />
  );
};
